<app-vis-dialog class="main-panel" [show]="show" (close)="close()">
    <app-search-bar>
        <app-vis-dropdownlist searchBarField [fieldTitle]="'尺寸'" [data]="sizeOpt"
            [(ngModel)]="size"></app-vis-dropdownlist>
        <app-vis-dropdownlist searchBarField [fieldTitle]="'密度'" [data]="densityOpt"
            [(ngModel)]="density"></app-vis-dropdownlist>
        <div searchBarField>{{timeText}}</div>
        <div searchBarField style="display: flex;">
            <mat-icon *ngFor="let life of lifes" style="color: red;">{{life.state?'favorite':'heart_broken'}}</mat-icon>
        </div>
        <button (click)="this.initGame()">{{isOver?'開始':'重來'}}</button>
    </app-search-bar>

    <table class="mine-grid">
        <div class="msg-mask" *ngIf="msg">
            <div>{{msg}}</div>
        </div>
        <div class="pause-mask" *ngIf="isPaused">
        </div>
        <tr *ngFor="let row of mines;let y=index" [ngStyle]="{height:cellHeight}">
            <td *ngFor="let cell of row;let x=index" class="mine-cell" [ngStyle]="{width:cellWidth}"
                [ngClass]="[cell.state,cellCls,cell.exCls]" (click)="openMine(y,x)" (contextmenu)="setFlag(y,x,$event)"
                [id]="'mine-'+y+'-'+x">
                <ng-container *ngIf="cell.state=='flag'">
                    <mat-icon>flag</mat-icon>
                </ng-container>
                <ng-container *ngIf="cell.state=='bomb'">
                    <mat-icon>sentiment_very_dissatisfied</mat-icon>
                </ng-container>
                <ng-container *ngIf="cell.state=='open'">
                    {{cell.text}}
                    <ng-container *ngIf="cell.icon=='f'">
                        <mat-icon style="color: violet;">local_florist</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="cell.icon=='g'">
                        <mat-icon style="color: green;">grass</mat-icon>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="cell.state=='hide'">
                    <div style="width: 100%;height: 100%;"></div>
                </ng-container>
            </td>
        </tr>
    </table>
    <div class="item-bar" style="display: flex;">
        <div *ngFor="let item of items">
            <div class="item-btn" (click)="item.Use($event)">
                <mat-icon>{{item.icon}}</mat-icon>
            </div>
            <div>{{item.desc}} x {{item.times}}</div>
        </div>
    </div>
    
    <div class="rocket-box" #rocketDiv [hidden]="!playRocket">
        <mat-icon>rocket</mat-icon>
    </div>
</app-vis-dialog>